import{createContext as r}from"react";var o=r({storage:"localStorage"});export{o as StorageConfig};
